import { useEffect, useRef } from 'react';
import { reduxForm } from 'redux-form';
import moment from 'moment';

import { useTranslation } from 'react-i18next';

import { Filters } from 'libs/form';

const d = moment();
const initialFlt = {
  // status: 'active',
  datetime_from: d.startOf('day').format(),
  datetime_to: d.endOf('day').format(),
};

const Filter = (props) => {
  const { locationState, reset, handleSubmit, change, type, isPlate } = props;
  const formRef = useRef(null);

  const { t } = useTranslation();

  /**
   * set filter
   * @param {*} field
   * @param {*} value
   */
  const setFilter = (field, value) => {
    change(field, value);
  };

  /**
   * update filter
   * @param {*} filter
   */
  const updateFilter = (filter) => {
    reset();
    for (let field in filter) {
      setFilter(field, filter[field]);
    }

    setTimeout(() => {
      formRef.current.dispatchEvent(new Event('submit'));
    }, 500);
  };

  // did mount
  useEffect(() => {
    if (locationState && locationState.filter) {
      updateFilter(locationState.filter);
    }
  }, []);

  const filters = [
    { type: 'doubledate', name: 'datetime', title: t('grid.Дата и время'), change },
    { type: 'input', name: 'vehicle_plate', title: t('sections.ГРЗ'), placeholder: t('form.А000AA 000 rus') },
    { type: 'dict', w: 150, dict: 'passage.type', multiple: true },
    { type: 'dict', w: 150, dict: 'passage.result' },
    { type: 'zones', w: 150, name: 'zones_from', title: t('grid.Зона из'), change },
    { type: 'racks', w: 180, name: 'rack_ids', title: t('grid.Узел/стойка') },
    { type: 'zones', w: 150, name: 'zones_to', title: t('grid.Зона в'), change },

    { type: 'classes', w: 150 },
    { type: 'parking' },
    {
      type: 'meandouble',
      dict: 'payment_mean_type',
      multiple: true,
      name: 'mean_number',
      placeholder: '55030',
      label: t('grid.СО'),
      w: 160,
      isHidden: isPlate,
    },
    { type: 'dict', w: 120, dict: 'passage.list', isHidden: !isPlate },
    { type: 'input', name: 'csc_owner', title: t('form.Держатель'), placeholder: t('form.Введите текст для поиска') },
    { type: 'input', name: 'client_name', title: t('form.Клиент'), placeholder: t('form.Введите текст для поиска'), isHidden: isPlate },
    { type: 'toggle', name: 'is_suspicious', title: t('grid.Подозрительные проезды'), isHidden: isPlate },
  ];

  return <Filters ref={formRef} items={filters} page={type} handleSubmit={handleSubmit} reset={reset} t={t} />;
};

export default reduxForm({
  form: 'passageFilter',
  // destroyOnUnmount: false,
  initialValues: initialFlt,
})(Filter);
